import { CatModal } from '@blocks-react/components/Modal';
import { MyEquipmentViewProps } from '../types';

export const MyEquipmentView = ({
  children,
  onBlModalClose,
  isActive,
  size,
  classname
}: MyEquipmentViewProps) => {
  return (
    <CatModal
      onBlModalClose={onBlModalClose}
      isActive={isActive}
      size={size}
      className={classname}
    >
      {children}
    </CatModal>
  );
};
